import { useForm } from "react-hook-form";
import { z } from "zod";
import { useContext } from "react";
import UserContext from "./UserProvider";
import { registerAccount } from "../api/account";
import { zodResolver } from "@hookform/resolvers/zod";
import { TextField, InputAdornment } from "@mui/material";
import { useNotify } from "../hooks/NotifyProvider";
import { PrimaryButton } from "../ui/PrimaryButton";
export const HandleRegister = ({ account, updated }) => {
  const { notify } = useNotify();
  const { setUser, setToken } = useContext(UserContext);
  const allowedChars = /^[a-zA-Z0-9_-]+$/;
  const formSchema = z.object({
    handle: z
      .string()
      .min(1, "ID is required.")
      .max(30, "Please enter a user ID within 30 characters")
      .regex(allowedChars, {
        message: "Only letters, numbers, and -._~ are allowed.",
      }),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      handle: "",
    },
  });
  const onSubmit = async (values) => {
    try {
      const params = {
        handle: values.handle,
        registrationToken: account.registrationToken,
      };
      const result = await registerAccount(params);

      setUser(result.data.user);
      setToken(result.data.sessionToken);
      notify("You've successfully created your account!", "success");
      updated && updated();
    } catch (error) {
      if (error.response?.status === 400 && error.response?.data?.message) {
        const errorMessage = error.response.data.message;
        if (errorMessage.includes("handle")) {
          setError("handle", {
            type: "manual",
            message: errorMessage,
          });
        } else {
          notify(errorMessage, "error");
        }
      } else {
        notify("Failed to change profile.", "error");
      }
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextField
          {...register("handle")}
          label="your ID"
          variant="standard"
          fullWidth
          margin="normal"
          error={!!errors.handle}
          helperText={
            errors.handle?.message
              ? errors.handle.message
              : "Pick a unique Id like @john_doe or @lisa-dev."
          }
          InputProps={{
            startAdornment: <InputAdornment position="start">@</InputAdornment>,
          }}
        />
        <div className="font-soft text-sm mt-3">
          You can change your display name later in your profile settings.
        </div>
        <div className="flex justify-end mr-6 mt-3">
          <PrimaryButton
            type="submit"
            sx={{ fontFamily: "'Nunito sans'", width: "150px" }}
          >
            create!
          </PrimaryButton>
        </div>
      </form>
    </div>
  );
};
